// extracted by mini-css-extract-plugin
module.exports = {"cityListEl_wrapper":"CityList_cityListEl_wrapper__37diL","cityList_container":"CityList_cityList_container__2CsLg","citylist_p":"CityList_citylist_p__3jZ-4"};